<template>
  <div class="comparisonTree">
    <div class="timeBox">
      <el-select
        v-model="timeType"
        value-key="key"
        placeholder="请选择"
        style="width: 25%"
        size="small"
        @change="getDataValue"
      >
        <el-option
          v-for="v in dateList"
          :label="v.name"
          :value="v"
          :key="v.key"
        ></el-option>
      </el-select>
      <template v-if="timeType.value !== 'UNLIMITED'">
        <el-date-picker
          v-model="timeValue"
          size="small"
          :clearable="false"
          :type="timeType.key"
          :key="timeType.key"
          :placeholder="timeType.tip"
          :value-format="timeType.format"
          style="margin-left: 20px"
        >
        </el-date-picker>
      </template>
    </div>
    <div class="contrastBox">
      <el-radio-group v-model="contrastType" size="small" @change="changeType">
        <el-radio-button label="EC_">能耗对比</el-radio-button>
        <el-radio-button label="custom">参数对比</el-radio-button>
      </el-radio-group>
    </div>
    <el-form label-width="60px" v-if="contrastType == 'custom'">
      <el-form-item label="参数">
        <el-select
          v-model="parameter"
          placeholder="请选择对比参数"
          @change="getTree"
          value-key="key"
        >
          <el-option
            v-for="item in options"
            :key="item.key"
            :label="item.name"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-radio-group v-model="typeFiltering" size="mini" @change="getTree">
      <el-radio-button label="分项系统">系统</el-radio-button>
      <el-radio-button label="区域位置">区域</el-radio-button>
      <el-radio-button label="单位部门">部门</el-radio-button>
    </el-radio-group>
    <div style="width: 100%; height: 60%; margin: 10px 0 20px 0">
      <el-tree
        :data="treeData"
        :props="defaultProps"
        node-key="id"
        highlight-current
        accordion
        show-checkbox
        :check-strictly="true"
        :default-expanded-keys="defaultKeys"
        ref="tree"
        style="
          overflow: auto;
          background: #f7f7f7;
          border: 1px solid #e7e7e7;
          border-radius: 6px;
          padding: 20px 0 30px;
          margin-top: 10px;
          height: 90%;
        "
      >
      </el-tree>
    </div>
    <div class="btnBox">
      <el-button type="primary" icon="el-icon-search" @click="searchBtn"
        >搜索</el-button
      >
      <el-button @click="resetting">重置</el-button>
    </div>
  </div>
</template>

<script>
import { dateFtt } from "@/assets/js/utils";
import api from "@/api";
export default {
  data() {
    return {
      options: [],
      dateList: [
        {
          name: "日",
          value: "DAY",
          key: "date",
          tip: "选择日期",
          format: "yyyy-MM-dd",
          showTime: "hh:mm:ss",
        },
        {
          name: "月",
          value: "MONTH",
          key: "month",
          tip: "选择月",
          format: "yyyy-MM",
          showTime: "MM月dd日",
        },
        {
          name: "年",
          value: "YEAR",
          key: "year",
          tip: "选择年",
          format: "yyyy",
          showTime: "yyyy年MM月",
        },
        {
          name: "全部",
          value: "UNLIMITED",
          showTime: "yyyy年",
        },
      ],
      timeType: {},
      timeValue: "",
      typeFiltering: "分项系统",
      contrastType: "EC_",
      parameter: {},
      treeData: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      defaultKeys: [], //默认打开
    };
  },
  methods: {
    resetting() {
      this.timeType = this.dateList[0];
      this.getDataValue();
      this.typeFiltering = "分项系统";
      this.contrastType = "EC_";
      this.getTree();
    },
    changeType() {
      if (this.contrastType == "custom") {
        this.parameter = this.options[0];
      }
      this.getTree();
    },
    searchBtn() {
      let arr = this.$refs.tree.getCheckedNodes();
      if (arr.length > 10) {
        this.$message.error("最多可选择10条");
      } else if (arr.length > 0) {
        this.$emit("ECchangeTree", {
          timeType: this.timeType,
          timeValue: this.timeValue,
          unit: this.contrastType == "EC_" ? "kw·h" : this.parameter.unit,
          treeValue: arr,
          typeKey:
            this.contrastType == "EC_" ? this.contrastType : this.parameter.key,
          name: this.contrastType == "EC_" ? "能耗" : this.parameter.name,
        });
      } else {
        this.$message.error("未选择资产！");
      }
    },
    getDataValue() {
      this.timeValue = this.timeType.format
        ? dateFtt(this.timeType.format, new Date())
        : null;
    },
    async getTree(type) {
      this.$store.commit("SET_LOADING", true);
      this.treeData = [];
      let key =
        this.contrastType == "EC_" ? this.contrastType : this.parameter.key;
      if (!key) {
        this.$message.error("请选择自定义属性!");
        this.$store.commit("SET_LOADING", false);
        return;
      }
      let res = await api.getAssetTreeByParameter({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        option: "HasEUDevice",
        maxLevel: 4,
        key: key,
        assetType: this.typeFiltering,
      });
      if (res && res.status == 200) {
        if (res.data) {
          this.treeData.push(res.data);
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey();
            this.defaultKeys = [];
            this.defaultKeys.push(this.treeData[0].id);
            this.$refs.tree.setCheckedNodes([this.treeData[0]]);
            if (type == "created") {
              this.searchBtn();
            }
          });
        }
        this.$store.commit("SET_LOADING", false);
      }
    },
  },
  created() {
    this.$store
      .dispatch("handleParameterKey", {
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
      })
      .then((res) => {
        this.options = res;
      });
    this.timeType = this.dateList[0];
    this.getDataValue();
    this.getTree("created");
  },
};
</script>

<style lang="scss" scoped>
.comparisonTree {
  width: 93%;
  height: 93%;
  margin: 5% auto;
  overflow: auto;
  // ::v-deep
  //   .el-tree--highlight-current
  //   .el-tree-node.is-current
  //   > .el-tree-node__content {
  //   background-color: $themeColor !important;
  //   color: #fff;
  // }
  .timeBox {
    @include setFlexBetween;
  }
  .contrastBox {
    margin: 20px 0;
  }
  .btnBox {
    @include setFlexCenter;
  }
}
</style>
